import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export function UserAvatarMenu() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    function onDown(e) {
      if (!open) return;
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    }
    function onKey(e) { if (e.key === "Escape") setOpen(false); }
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <div ref={rootRef} className="relative">
      <button
        type="button"
        aria-label={isAuthenticated ? "Open user menu" : "Sign in"}
        onClick={() => { if (!isAuthenticated) { navigate("/login"); return; } setOpen((v) => !v); }}
        className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-all
          ${isAuthenticated
            ? 'border-primary/50 bg-primary/10 text-primary hover:border-primary hover:bg-primary/20 hover:scale-105'
            : 'border-slate-700 bg-slate-800/60 text-slate-400 hover:border-slate-500 hover:text-slate-300'}`}
      >
        <span
          className="material-symbols-outlined text-[22px]"
          style={isAuthenticated ? { fontVariationSettings: "'FILL' 1" } : {}}
        >
          person
        </span>
      </button>

      {open && (
        <div className="absolute right-0 mt-3 w-64 overflow-hidden rounded-xl border border-white/10 bg-slate-900 shadow-2xl shadow-black/50">
          {/* User info header */}
          <div className="flex items-center gap-3 border-b border-white/10 px-4 py-4">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-primary/40 bg-primary/15 text-primary">
              <span
                className="material-symbols-outlined text-[18px]"
                style={{ fontVariationSettings: "'FILL' 1" }}
              >
                person
              </span>
            </div>
            <div className="min-w-0">
              <p className="truncate text-sm font-black text-white">{user?.name}</p>
              <p className="truncate text-xs text-slate-400">{user?.email}</p>
            </div>
          </div>

          {/* Menu items */}
          <div className="p-2">
            <button
              type="button"
              className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm font-bold text-white hover:bg-white/5 transition"
              onClick={() => { setOpen(false); navigate("/console"); }}
            >
              Open Console
              <span className="material-symbols-outlined text-[16px] text-slate-400">terminal</span>
            </button>
            <button
              type="button"
              className="flex w-full items-center justify-between rounded-lg px-3 py-2 text-sm font-bold text-slate-300 hover:bg-white/5 hover:text-white transition"
              onClick={() => { setOpen(false); logout(); navigate("/", { replace: true }); }}
            >
              Logout
              <span className="material-symbols-outlined text-[16px] text-slate-400">logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
